<template>
  <label tabindex="0" class="tw-checkbox-container tw-label-new" :title="labelTitle" role="checkbox" :aria-checked="modelValue" @keyup="keyup">
    <input type="checkbox" class="hidden" v-model="model" :value="value" :disabled="disabled" >
    <span class="tw-checkbox-container-box"
          :class="{'tw-checkbox-container-box-disabled': disabled,
                  'tw-checkbox-container-box-large': size ==='large',
                  'tw-checkbox-green': color === 'green',
                  'tw-checkbox-blue': color === 'blue',
                  'tw-checkbox-error': error,
                  }"></span>
    <span class="tw-checkbox-container-checkmark tw-icon"
          :class="{
                  'check-large h-4 w-4 ml-0.5': !disabled && size === 'large',
                  'check tw-icon-tiny ml-[3px]': !disabled && size !== 'large',
                  'check-large-disabled h-4 w-4 ml-0.5': disabled && size === 'large',
                  'check-disabled tw-icon-tiny ml-[3px]': disabled && size !== 'large',
                  'tw-checkbox-green': !disabled && color === 'green',
                  'tw-checkbox-blue': !disabled && color === 'blue' }"
    />
    <span :class="getClass" >{{label}}</span>
    <slot />
  </label>
</template>

<script >
export default {
  props:{
    modelValue: { type: [Array, Boolean] },
    value: { type: [Boolean, Object, String] },
    label: { type: String },
    disabled:{default: false},
    size:{ type: String, default: 'normal' },
    color:{ type: String, default: 'blue' },
    labelClasses: {type: String, default: undefined},
    labelTitle: {type: String, default: undefined},
    error: {type: Boolean, default: false}
  },
  computed:{
    getClass(){
      return this.labelClasses ? this.labelClasses : 'tw-text-sm h-5'
    },
    model:{
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
        this.$emit('customClick', value)
      }
    }
  },
  methods:{
    keyup(e){
      if(e.keyCode === 13){
        this.model = !this.modelValue
      }
    }
  }
}
</script>